import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { recentInvoicesQueryOptions } from "@/app/billing/api/get-recent-invoices";
import { upcomingInvoiceQueryOptions } from "@/app/billing/api/get-upcoming-invoice";
import { InvoicesPageSkeleton } from "@/app/billing/invoices/components/invoices-page-skeleton";
import { InvoicesPage } from "@/app/billing/invoices/invoices";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices"
)({
  beforeLoad: ({ context: { queryClient }, params }) => {
    const organizationId = params.organizationId;

    queryClient.prefetchQuery(upcomingInvoiceQueryOptions({ organizationId }));
    queryClient.prefetchQuery(recentInvoicesQueryOptions({ organizationId }));
  },
  loader: () => ({
    crumb: "Invoices",
  }),
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<InvoicesPageSkeleton />}>
      <InvoicesPage />
    </Suspense>
  ),
});
